import { msg } from '@lingui/macro';
import { IconArchive } from '@tabler/icons-react';
import type { ImporterDescriptor } from '../../../descriptors/types';

const descriptor: ImporterDescriptor = {
  id: 'productImport',
  status: 'legacy',
  category: 'product-data',
  icon: IconArchive,
  title: msg`Product import (legacy)`,
  shortTitle: msg`Product import (legacy)`,
  whenToUse: msg`Older product import flow. Use the Product data import instead.`,
  outputDescription: msg`Creates or updates products in your portfolio (legacy flow).`,
  intents: ['Legacy product import'],
  keywords: ['legacy', 'product', 'old'],
  synonyms: [],
  inputHints: {
    fileTypes: ['xlsx'],
    sampleHeaders: [],
    requiredColumns: [],
  },
};

export default descriptor;
